import { Injectable } from '@angular/core'
import type { LivePageProperties, SegmentTagV2 } from '../shared/analytics/models/segment-tag.model'
import { SegmentService } from '../shared/analytics/services/segment.service'

/**
 * The standard Page tag for the live player page view.
 *
 * @remarks
 * This is expected to be used with pageV2, as indicated by the use of the
 * SegmentTagV2 interface and `autoPageCall: false`.
 *
 * @see SegmentService#pageV2
 * @see SegmentTagV2
 */
export const LIVE_TAG: SegmentTagV2 = {
  page_category: 'Live',
  category: 'Live',
  autoPageCall: false
}

@Injectable()
export class LiveAnalyticsService {
  public constructor(private readonly segment: SegmentService) {}

  public sendPageCall(liveId: number, isPremium: boolean): void {
    const pageProperties: LivePageProperties = {
      _tag: 'live',
      live_id: liveId,
      is_premium: isPremium
    }
    this.segment.pageV2(LIVE_TAG, pageProperties)
  }
}
